import { useTranslations } from 'next-intl';
import { useElementErrorMsg, useFetch, useGlobalModal } from '@/app/hooks';
import { materialsDeleteLabel } from '../apis';

export const useDeleteLabelConfirmDialog = ({ onDelete }: { onDelete?: (id: string) => void }) => {
  const t = useTranslations('elements.deleteTag');
  const { showErrorMsg, showSuccessMsg } = useElementErrorMsg();

  const { close: closeConfirmDialog, open: openConfirmDialog } = useGlobalModal('confirmDialog');

  const { loading: deleteLoading, run: deleteTag } = useFetch(
    (id: string) =>
      materialsDeleteLabel({
        path: {
          id,
        },
      }),
    {
      manual: true,
      onSuccess: (data, [id]) => {
        if (data.error) {
          showErrorMsg(data.error);
        } else {
          showSuccessMsg();
          onDelete?.(id);
          closeConfirmDialog();
        }
      },
    },
  );

  const openDeleteConfirmDialog = (id: string) => {
    openConfirmDialog({
      content: t('title'),
      secondaryButtonText: t('leftBtn'),
      primaryButtonText: t('rightBtn'),
      onPrimaryAction: () => deleteTag(id),
    });
  };

  return {
    openDeleteConfirmDialog,
    deleteLoading,
  };
};
